import { useState } from 'react'
import BusinessProduct from './BusinessProduct'
import EditProductModal from 'pages/Modals/EditProductModal'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function BusinessProductList ({
  products = [],
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [productData, setProductData] = useState (null)
  const [showEditProductModal, setShowEditProductModal] = useState (false)
  
  const editProduct = product => {
    setProductData (product)
    toggleEditProductModal ()
  }

  const toggleEditProductModal = () => setShowEditProductModal (!showEditProductModal) 

  if (products.length === 0) return (
    <Container>
      <InfoText>Você ainda não possui produtos cadastrados</InfoText>
    </Container>
  )

  return (
    <Container>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Estoque</SubTitle>
        <SubTitle>Finalidade</SubTitle>
        <SubTitle>Preço</SubTitle>
        <SubTitle>Comissão de venda</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {products.map ((product, index) => (
        <BusinessProduct
          key={index}
          data={product}
          onEdit={editProduct}
          onDelete={handleDelete}
        />
      ))}
      {!!productData && (
        <EditProductModal
          visible={showEditProductModal}
          data={productData}
          onConfirm={handleEdit}
          onClose={toggleEditProductModal}
        />
      )}
    </Container>
  )
}
